import { apiClient } from "./apiClient";

const resendBulkClassification = async (payload: {
  documentUUIDs: string[];
  ranBy: string;
  totalDocuments?: number;
}) => {
  const res = await apiClient.post(`/document-analytics/bulk/resend/classification`, payload);
  return res.data;
};

const getOthersBatchData = async (params: {
  fromDate?: string;
  toDate?: string;
  status?: string;
  runId?: string;
}) => {
  const { data } = await apiClient.get(`/others/fetch/resend-classification`, { params });
  return data;
};
 
export const otherService = {
  resendBulkClassification,
  getOthersBatchData,
};
